import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import Box from '@mui/material/Box';
import FullScreenLoader from '../FullScreenLoader';

const MainContent = () => {
  return (
    <Box component="main" sx={{ flex: 1, minWidth: 0, mt: '52px' }}>
      <Box sx={{ height: '100%' }}>
        <Suspense fallback={<FullScreenLoader />}>
          <Outlet />
        </Suspense>
      </Box>
    </Box>
  );
};

export default MainContent;
